import sundayServiceCover from '../assets/watch/sunday-service-cover.png';
import churchAnniversaryPlaylistCover from '../assets/watch/church-anniversary-playlist-cover.jpg';
import bibleStudyPlaylistCover from '../assets/watch/bible-study-playlist-cover.jpg';

const CHURCH_ANNIVERSARY_PLAYLIST =
  'https://youtube.com/playlist?list=PLiORm3vNL7tYIo4st2UEC3x71N6asZSCm&si=--G3bM7HHHrhL1rU';

const BIBLE_STUDY_PLAYLIST =
  'https://youtube.com/playlist?list=PLiORm3vNL7tY1TBO9xv4RRpHtLXEDb2XK&si=8e3aqmsOk5mMv5vI';

export const DEFAULT_WATCH_SECTIONS = [
  {
    title: 'Shorts',
    videos: [
      {
        url: 'https://youtube.com/shorts/LNHa9YyiEx0?si=JGb2blHlUTVXGFZN',
        thumbnail: 'https://i.ytimg.com/vi/LNHa9YyiEx0/hq2.jpg',
        alt: 'PSAG Short',
      },
      'https://www.youtube.com/shorts/orZ6arMQjc8',
      'https://www.youtube.com/shorts/jkCw8Y_iApM',
      'https://www.youtube.com/shorts/XYg0W4v_TO8',
      {
        url: 'https://youtube.com/shorts/NByFw2TdlOI?si=oBD5Kd9Y5wA2j21m',
        thumbnail: 'https://i.ytimg.com/vi/NByFw2TdlOI/hq2.jpg',
        alt: 'PSAG Short',
      },
      'https://youtube.com/shorts/3BecONhWa4c?si=2i6a14LsPofD1c_Z',
    ],
    moreLink: 'https://www.youtube.com/@psagchurch/shorts',
  },
  {
    title: 'Messages',
    videos: [
      {
        url: BIBLE_STUDY_PLAYLIST,
        thumbnail: bibleStudyPlaylistCover,
        alt: 'Bible Study: Church playlist',
        isPlaylist: true,
      },
      'https://www.youtube.com/watch?v=u3ZOo_jEUdY',
      'https://www.youtube.com/watch?v=l85wuVodr8w',
      'https://www.youtube.com/watch?v=Xg7iUIzpWw8',
      'https://www.youtube.com/watch?v=qkNxB5hxZGg',
      'https://www.youtube.com/watch?v=hi6xs8ozvA8',
    ],
    moreLink: 'https://www.youtube.com/@psagchurch/videos',
  },
  {
    title: 'Sunday Services',
    videos: [
      'https://www.youtube.com/watch?v=l3WL05vRc0Q',
      'https://www.youtube.com/watch?v=Z4jCbgan5PI',
      'https://www.youtube.com/watch?v=-ffqjRbUWiY',
      'https://www.youtube.com/watch?v=kx8eN2-Y-zQ',
    ],
    moreLink: 'https://www.youtube.com/@psagchurch/streams',
    coverSrc: sundayServiceCover,
  },
  {
    title: 'Other Events',
    videos: [
      {
        url: CHURCH_ANNIVERSARY_PLAYLIST,
        thumbnail: churchAnniversaryPlaylistCover,
        alt: '2025-2026 Church Anniversary playlist',
      },
      'https://www.youtube.com/live/Cui6H6gx0Ow?si=odaledhb1OolcPWk',
      'https://www.youtube.com/live/K9M5H33E120?si=YzXAxWHPXBnhziES',
      'https://www.youtube.com/live/WpWhvCHYmHc?si=g_yxUzm0MH5Mk-hw',
    ],
    moreLink: 'https://www.youtube.com/@psagchurch/streams',
  },
];

export function resolveWatchSections(getContent) {
  return DEFAULT_WATCH_SECTIONS.map((section, index) => {
    const storedVideos = getContent(`watch.section.${index}.videos`, null);
    return {
      ...section,
      title: getContent(`watch.section.${index}.title`, section.title),
      moreLink: getContent(`watch.section.${index}.moreLink`, section.moreLink),
      coverSrc: getContent(`watch.section.${index}.coverSrc`, section.coverSrc),
      videos: Array.isArray(storedVideos) ? storedVideos : section.videos,
    };
  });
}
